(function(angular){
	'use strict';
	
	var planThreeFeaturedAssetObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			assets: '<'
		},
		controller: [
			'$rootScope', 
			'PropertyService', 
			PlanThreeFeaturedAssetFunction
		],
		controllerAs: 'planThreeAssets'
	};
	
	angular
		.module('viewPlanModule')
		.component('planThreeFeaturedAssets', planThreeFeaturedAssetObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-three-featured-asset.html';
	}
	
	function PlanThreeFeaturedAssetFunction(
		$rootScope,
		PropertyService
	){
		var planThreeAssets = this;
		var numberOfAssetsToDisplay = 3;

		function formatAssets() {
			planThreeAssets.featuredAssets = [];
			planThreeAssets.assets = planThreeAssets.assets || [];
			planThreeAssets.featuredAssets = planThreeAssets.assets.slice(0, numberOfAssetsToDisplay);

			while(planThreeAssets.featuredAssets.length < numberOfAssetsToDisplay) {
				planThreeAssets.featuredAssets.push({
					empty: true,
					rating: {
						color: '#d5d9dc'
					}
				});				
			}
		}

		planThreeAssets.openModal = function(reitElement) {
			if(!reitElement.empty) {
				$rootScope.ModalFactory.openReitElement({
					reitElement: reitElement
				});
			}
		};

		planThreeAssets.$onChanges = function() {
			formatAssets();
		};

		planThreeAssets.$onInit = function() {
			formatAssets();
		};
	}
})(window.angular);